import _ from 'lodash'
import qs from 'qs'
import { TRANSFER_BASE_URL } from '../constants'
import { location } from '../stores/configureHistory'

/**
 * Returns the current URL fragment (url minus root and without trailing slash)
 * '/myaccount/transfer/send' -> '/send'
 *
 * @param path {String} (optional) - a path (like an href attribute)
 * @returns {String}
 */
export function getUrlFragment(
  path = document.location.pathname,
  // lazily require the store to avoid cyclic dependency
  root = require('../stores/configureStore').default.getState().server
    .rootURL || TRANSFER_BASE_URL
) {
  const url = path.replace(root, '')
  return url.replace(/\/$/, '')
}

/**
 * Returns the referrer ULR (parent URL) only if it is not the top frame.
 * This method catches the exception so that we don't have to do it everywhere.
 */
export function getReferrerUrl() {
  const parentUrl = document && document.referrer
  try {
    return new URL(parentUrl)
  } catch (e) {
    return null
  }
}

export function getFlowType(url = window.location.pathname || '') {
  const flowTypes = ['send', 'buy', 'request', 'payRequest']
  return flowTypes.find(flow => url.includes(flow)) || ''
}

export function parseSearch(search = location.search) {
  const queryString = search.split('?')[1]
  if (!queryString) {
    return {}
  }
  return _.fromPairs(
    _.compact(
      _.map(
        queryString.split('&'),
        item => item && item.split('=').map(decodeURIComponent)
      )
    )
  )
}

export function safeParseWindowSearch(_window) {
  try {
    return parseSearch(_window.location.search)
  } catch (ex) {
    // Possible CORS error when trying to access window object from parent domain.
    // Most likely due to P2P opened inside an iframe outside of the PayPal.com domain.
    return {}
  }
}

// Update or add a query param with a new value and leverages the qs library to do so
export function updateQueryStringParameter(queryString, key, value) {
  // We do not expect this function to decode any values
  // so we simply override qs's built in decoder to return all values itself
  const decoder = keyOrValue => keyOrValue

  // ignore query prefix so that the parsed object does not contain ? in the first key
  const parsedObject = qs.parse(queryString, {
    ignoreQueryPrefix: true,
    decoder,
  })
  parsedObject[key] = value

  // stringify and add back the ? prefix in the string
  // We do not expect this function to encode, so we set it to false
  return qs.stringify(parsedObject, { addQueryPrefix: true, encode: false })
}
